const Candidate = () => import('../views/Candidate.vue')

export default [
  {
    path: 'candidates',
    component: Candidate,
    meta: { requiresAuth: true },
    name: 'root.candidates'
  }
]